export const faqs = [
  {
    q: "提交举报后，多久能收到受理结果？",
    a: "线索提交成功后即时生成受理编号，平台会在 24 小时内完成初步受理，确认线索是否完整以及是否属于受理范围，并通过站内信与邮箱同步受理结论。",
  },
  {
    q: "直播间画面突然中断，我可以反馈哪些信息？",
    a: "请尽量提供直播平台、房间名称、发生时间与持续时长，并说明是否出现音频丢失、消息回滚、付费环节被中断等情况。信息越具体，核查效率越高。",
  },
  {
    q: "举报主播违规需要上传证据吗？",
    a: "建议提供截图、录屏链接或对话记录等可核验材料。缺乏材料的线索也可以提交，平台会结合公开回放进行核查，但补充材料通常能明显缩短核查周期。",
  },
  {
    q: "我的个人信息会被公开吗？",
    a: "不会。举报人信息严格保密，未获授权不会向被举报方披露。进入公示区的内容仅保留事件概述与处理结果，个人敏感信息会被隐去。",
  },
  {
    q: "被举报的一方可以申诉吗？",
    a: "可以。平台设有双向申诉机制，被举报方可在公示期内提交说明与反证材料，平台会据实复核并更新核查结论，避免单方面定性。",
  },
  {
    q: "为什么有些事件长时间显示“核查中”？",
    a: "涉及多方取证、需要第三方材料或存在争议焦点的事件，核查周期会更长。核查期间平台会持续更新事件时间线，举报人可凭受理编号随时查询进度。",
  },
  {
    q: "处理结果会对外公示吗？",
    a: "会在处理结果公示区对外展示，并标注处置类型与完成时间。除涉及隐私或正在调查中的内容外，绝大多数处理结果都会公开，以接受回看与复盘。",
  },
  {
    q: "对处理结果不满意，还能做什么？",
    a: "可以在结果同步后 7 个工作日内提交复核申请，并补充新的证明材料。平台将组织二次核查，复核结论同样会同步给举报人。",
  },
];